import {Injectable, Type} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {
    BmDunningTypeTriggerObjectComponent
} from "../../component/object-components/bm-dunning-type-trigger-object-component/bm-dunning-type-trigger-object.component";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";

@Injectable({
  providedIn: 'root'
})
export class DunningTypeTriggerService extends MvsCrudService{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/bm/dunningTypeTriggers')
  }


  getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
    if(mode != MvsCrudModeEnum.create){
      return BmDunningTypeTriggerObjectComponent;
    }
    return null;
  }
}
